import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames, useState } from 'libs/react';
import { useIdent } from 'libs/react';
import { useWatch } from 'libs/react';
import { DateInput } from './private/inputs/DateInput';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { TimeInput } from './private/inputs/TimeInput';
import './FormDate.scss';
/**
 * @component FormDate
 * @since 1.0.0
 */
export function FormDate(props) {
    let { name, size, date, time, minDate, maxDate, minTime, maxTime, lang, style, picto, badge, label, infos, error, required, optional, disabled, placeholder, tooltip, prefix, selectsRange, suffix, timeOnly, yearOnly, isClearable } = Object.assign({ size: 'medium', lang: 'fr', date: true, time: true, style: 'normal', picto: props.timeOnly ? 'clock' : 'calendar-alt' }, props);
    const defaultPlaceholder = yearOnly
        ? lang == 'en'
            ? t('yyyy')
            : t('aaaa')
        : time
            ? lang == 'en'
                ? t('yyyy-mm-dd - hh:mm:ss')
                : t('aaaa-mm-jj - hh:mm:ss')
            : selectsRange
                ? lang == 'en'
                    ? t('yyyy-mm-dd - yyyy-mm-dd')
                    : t('aaaa-mm-jj - aaaa-mm-jj')
                : lang == 'en'
                    ? t('yyyy-mm-dd')
                    : t('aaaa-mm-jj');
    const form = useForm();
    const [ident] = useIdent('form-date');
    const [isFocused, setFocused] = useState(false);
    const [value, setValue] = useValue(name, props.value, props.defaultValue || null);
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(date) {
        if (date instanceof Date) {
            if (timeOnly) {
                const hh = String(date.getHours()).padStart(2, '0');
                const mm = String(date.getMinutes()).padStart(2, '0');
                setValue(`${hh}:${mm}`);
            }
            else {
                setValue(date.toISOString());
            }
        }
        else if (date instanceof Array) {
            setValue(date.map((date) => date.toISOString()).join(','));
        }
        else {
            setValue(null);
        }
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur(value);
        }
    }
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-date', 'form-date--' + size, 'form-date--' + style, { 'form-date--is-required': required }, { 'form-date--is-optional': optional }, { 'form-date--is-disabled': disabled }, { 'form-date--is-clearable': isClearable }, { 'form-date--has-label': label }, { 'form-date--has-value': value }, { 'form-date--has-picto': picto }, { 'form-date--has-badge': badge }, { 'form-date--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-date-field" },
            React.createElement("div", { className: "form-date-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-date-label", size: size, style: style, label: label, ident: ident, tooltip: tooltip, required: required, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-date-infos", size: size, style: style, infos: infos }))),
            React.createElement("div", { className: "form-date-field-body" },
                prefix && React.createElement("div", { className: "form-date-input-prefix" }, prefix),
                timeOnly ? (React.createElement(TimeInput, { name: name, lang: lang, ident: ident, value: value, minTime: minTime, maxTime: maxTime, required: required, disabled: disabled, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'hh:mm:ss', onChange: onChange, onBlur: onBlur, focused: isFocused })) : (React.createElement(DateInput, { name: name, date: date, time: time, lang: lang, ident: ident, value: value, minDate: minDate, maxDate: maxDate, required: required, disabled: disabled, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : defaultPlaceholder, onChange: onChange, onBlur: onBlur, onCalendarOpen: props.onCalendarOpen, onCalendarClose: props.onCalendarClose, yearOnly: yearOnly, selectsRange: selectsRange, isClearable: isClearable, focused: isFocused, portalId: props.portalId })),
                picto && (React.createElement(Icon, { className: "form-date-picto", value: picto, onClick: () => setFocused(true) })),
                badge && React.createElement(Text, { className: "form-date-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-date-input-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
